<script setup lang="ts">
import TextBlockIt from "@/views/main/ContactsView/textBlockIt.vue"
import TextBlockEn from "@/views/main/ContactsView/textBlockEn.vue"

const selectedLanguage = I18n.locale
</script>

<template>
  <text-block-en v-if="selectedLanguage === 'en'" />

  <text-block-it v-else />

  <section class="body-font container relative text-gray-600">
    <div class="container mx-auto flex-wrap px-0 py-24 sm:flex-nowrap md:flex">
      <div
        class="relative flex h-[500px] w-full items-end justify-center overflow-hidden rounded-lg bg-gray-300 p-10 pb-6">
        <iframe
          width="100%"
          height="100%"
          class="absolute inset-0"
          frameborder="0"
          title="map"
          marginheight="0"
          marginwidth="0"
          scrolling="no"
          src="https://maps.google.com/maps?width=100%&amp;height=600&amp;hl=&amp;q=VIALE%20DE%20COUBERTIN,%2000196%20ROMA+(My%20Business%20Name)&amp;ie=UTF8&amp;t=&amp;z=14&amp;iwloc=B&amp;output=embed"></iframe>
      </div>
    </div>
  </section>
</template>
